function initLocalMessagesCache() {
  let assistantRefPrompts = [];
  return {
    getAssistantRefPrompts: () => assistantRefPrompts,
    setAssistantRefPrompts: (msg, msgs) => {
      if (msgs && Array.isArray(msgs)) {
        assistantRefPrompts = msgs;
      } else if (msg) {
        assistantRefPrompts.push(msg);
      }
    }
  };
}
/**
 * local cache for messages
 * @public
 */
export const localCache = initLocalMessagesCache();